module.exports = __webpack_public_path__ + "img/infografika.b1ace40f.png";